var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import classNames from 'clsx';
import * as React from 'react';
import Icon from '../icon';
import Theme from '../theme.config';
import { Styled } from './style';
var CheckboxRow = /** @class */ (function (_super) {
    __extends(CheckboxRow, _super);
    function CheckboxRow(props) {
        var _this = _super.call(this, props) || this;
        _this.onCheckboxClick = function (value) {
            _this.setState({ active: _this.state.active });
            if (_this.props.callback && !_this.state.active) {
                _this.props.callback(value);
            }
        };
        _this.state = {
            active: props.active || false,
        };
        return _this;
    }
    CheckboxRow.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.active !== prevState.active) {
            return { active: nextProps.active };
        }
        return null;
    };
    CheckboxRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, description = _a.description, activeDescription = _a.activeDescription, color = _a.color, value = _a.value;
        var active = this.state.active;
        var colors = {
            error: Theme.color.red,
            success: Theme.color.success,
            warning: Theme.color.warning,
        };
        return (React.createElement(Styled, { onClick: function () { return _this.onCheckboxClick(value); }, active: active, className: classNames({ active: 'active' }, this.props.className), color: (color && colors[color]) ? colors[color] : color ? color : Theme.color.darkGrey },
            React.createElement("div", { className: "icon" },
                React.createElement(Icon, { name: active ? 'checked-circle' : 'circle' })),
            React.createElement("div", { className: "core" },
                React.createElement("div", { className: "title" }, title),
                description && React.createElement("div", { className: "description" }, (description && active && activeDescription) ? activeDescription : description))));
    };
    return CheckboxRow;
}(React.Component));
export default CheckboxRow;
//# sourceMappingURL=index.js.map